const en: Record<string, string> = {
  // Top navigation
  'nav.file': 'File',
  'nav.examples': 'Scene Library',
  'nav.help': 'Help',
  'nav.community': 'Join Community',
  'nav.support': 'Support',

  // File dropdown
  'file.save': 'Save',
  'file.saveLocal': 'Download to Local',
  'file.open': 'Open',
  'file.clearScene': 'Clear Scene',

  // Edit mode
  'editMode.scene': 'Scene Editing',
  'editMode.animation': 'Animation',

  // Language switcher
  'lang.label': '中 / EN',
  'lang.zh': '中文',
  'lang.en': 'English',

  // User menu
  'user.vip': 'VIP',
  'user.credits': 'Credits',
  'user.currentCredits': 'Balance: ',
  'user.vipTitle': 'VIP Member',
  'user.vipExpire': 'Expires: ',
  'user.vipRemaining': ' (',
  'user.vipDays': ' days left)',
  'user.founderPrice': 'Founding Member Price',
  'user.vipPrice': '$9.99',
  'user.vipPriceUnit': '/mo',
  'user.creditsUnit': 'credits',
  'user.joinGroup': 'Join the WeChat group, get ',
  'user.joinGroupCredits': ' credits',
  'user.buyCredits': 'Buy Credits',
  'user.upgradePro': 'Upgrade to Pro',
  'user.logout': 'Log out',
  'app.brandName': 'Samelab',
  'user.aiCreditsLabel': 'Credits',
  'user.login': 'Log in',

  // Left panel toolbar
  'panel.layout': 'Layout',
  'panel.importModel': 'Import Model',
  'panel.aiImageToModel': 'AI Image to 3D',
  'panel.objectList': 'Object List',

  // Right panels
  'panel.panorama': 'Panorama',
  'panel.environment': 'Environment',
  'panel.cameraLabel': 'Camera:',
  'panel.aiGeneration': 'AI Generation',
  'panel.exportImage': 'Export Image',
  'panel.addCameraHint': 'Add at least one camera to your scene',
  'scene.exitGroupEdit': 'Exit Group Editing',

  // Object list
  'obj.lockSuccess': 'Locked',
  'obj.unlockSuccess': 'Unlocked',
  'obj.lockedHint': 'Locked. To edit again, unlock it in the Object List.',

  // Property edit panel
  'prop.boneEdit': 'Bone Pose Editor',

  // Bone pose editor
  'bone.more': 'More',
  'bone.exportContent': 'Export Content',
  'bone.currentFrame': 'Current Frame',
  'bone.wholeAnimation': 'Whole Animation',
  'bone.applyScope': 'Apply Scope',
  'bone.fullBody': 'Full Body',
  'bone.upperBody': 'Upper Body',
  'bone.lowerBody': 'Lower Body',
  'bone.head': 'Head',
  'bone.leftArm': 'Left Arm',
  'bone.rightArm': 'Right Arm',
  'bone.apply': 'Apply',
  'bone.allAnimations': 'All Animations',
  'bone.playFailed': 'Failed to play animation',
  'prop.moveToGroup': 'Move to Group',
  'prop.lock': 'Lock',
  'prop.unlock': 'Unlock',
  'prop.copy': 'Duplicate',
  'prop.editGroup': 'Edit Group',
  'prop.delete': 'Delete',

  // Sidebar (ObjTypeSelect)
  'sidebar.add': 'Add',
  'sidebar.recent': 'Recent: ',
  'sidebar.myAssets': 'My Assets',
  'sidebar.manageAssets': 'Manage Assets',
  'sidebar.contactSupport': 'Contact support to add',
  'sidebar.within24h': '(added within 24h)',
  'sidebar.userUpload': 'User upload',
  'sidebar.free': '(Free)',
  'sidebar.initScheme': 'Presets',

  // Add guide bubble
  'guide.addModelTitle': 'Add a model to your scene',
  'guide.addModelDesc': 'Click the Add button on the left and pick a model from the categories to start creating.',
  'guide.gotIt': 'Got it',
  'guide.close': 'Close guide',

  // Welcome / Template modal
  'welcome.title': 'Welcome to Samelab. Choose a template to create your scene.',
  'welcome.newEmpty': 'New Empty Scene',
  'welcome.openFile': 'Open File',
  'welcome.myScenes': 'My Scenes',
  'welcome.officialScenes': 'Official Scenes',
  'welcome.sceneNamePlaceholder': 'Enter scene name',

  // Export image modal
  'export.title': 'Export Image',
  'export.standard': 'Standard',
  'export.hd': 'HD',
  'export.ultraHd': 'Ultra HD',
  'export.customWidth': 'Custom width',
  'export.export': 'Export',
  'export.pro': 'Pro',

  // Common
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.close': 'Close',
  'common.loading': 'Loading...',
  'common.none': 'None',
  'common.noTexture': 'No Texture',
  'common.editTexture': 'Edit Texture',
  'common.allMaterials': 'All Materials',
  'common.selectType': 'Select a type',
  'common.allTypes': 'All Types',
  'common.delete': 'Delete',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.saveSuccess': 'Saved successfully',
  'common.saveFail': 'Save failed',
  'common.loadFail': 'Load failed',
  'common.saving': 'Saving...',

  // Angle editor
  'angle.radian': 'Radian: ',
  'angle.angle': 'Angle:',

  // Environment editor
  'env.title': 'Environment Settings',

  // Ground texture editor
  'gtexture.props': 'Properties',
  'gtexture.bg': 'Background',
  'gtexture.save': 'Save',
  'gtexture.saveScale': 'Save ({0}X)',
  'gtexture.clear': 'Clear',
  'gtexture.back': 'Back',
  'gtexture.deleteElement': 'Delete Element',
  'gtexture.moveUp': 'Move Up',
  'gtexture.moveDown': 'Move Down',
  'gtexture.hintPolygon': 'Click canvas to add vertices, double-click to finish (at least 3 points), press Esc to cancel',
  'gtexture.hintPolyline': 'Click canvas to add points, double-click to finish (at least 2 points), press Esc to cancel',

  // Hunyuan 3D tasks
  'hunyuan.generating': 'Generating model...',
  'hunyuan.useModel': 'Use Model',
  'hunyuan.moveToLibrary': 'Move to My Assets & Use',
  'hunyuan.moveSuccess': 'Moved successfully',
  'hunyuan.deleteConfirm': 'Delete this task and its model?',
  'hunyuan.deleteSuccess': 'Deleted successfully',

  // File / model operations
  'file.downloadFailed': 'File download failed, please retry',
  'file.formatUnsupported': 'Please upload an FBX, OBJ, or GLB file',
  'file.emptyFile': 'File "{0}" is 0 bytes. Please check if it is corrupted or empty',
  'file.tooLarge': 'File "{0}" is too large ({1} MB). Please upload a file smaller than {2}MB',
  'file.processFailed': 'Failed to process file, please try again',
  'file.buyModelConfirm': 'Buy this model? It will cost ',
  'file.buyModelCredits': ' credits',
  'file.buySuccess': 'Purchase successful',
  'file.buyFailed': 'Purchase failed',

  // Payment result page
  'payResult.verifying': 'Verifying payment status...',
  'payResult.successTitle': 'Purchase Successful',
  'payResult.successDesc': 'Your order has been paid. Thank you!',
  'payResult.orderNo': 'Order No.:',
  'payResult.closePage': 'Close',
  'payResult.failureTitle': 'Payment Verification Failed',
  'payResult.retry': 'Retry',
  'payResult.missingOrderNo': 'Missing order number parameter',
  'payResult.verifyFailed': 'Payment status verification failed',
  'payResult.networkError': 'Network request failed, please try again later',

  // Scene / drawing operations
  'scene.world': 'World',
  'scene.exitDrawing': 'Exit drawing',
  'scene.pleaseLogin': 'Please log in first',
  'scene.lockedObjWarn': 'Locked objects cannot be edited. Please unlock them in the Object List.',
  'scene.clearConfirm': 'Are you sure you want to clear all content?',
  'scene.logoutConfirm': 'Are you sure you want to log out?',

  // Edit panel labels
  'edit.messageLabel': 'Message',
  'edit.messageFontSize': 'Message Font Size',

  // Image edit panel
  'imgEdit.url': 'URL',
  'imgEdit.file': 'File',
  'imgEdit.urlPlaceholder': 'Enter image URL',
  'imgEdit.upload': 'Upload File',
  'imgEdit.historyTitle': 'Choose from History',
  'imgEdit.historyEmpty': 'No history images',
  'imgEdit.existingImages': 'Existing Images',
  'imgEdit.more': 'More',
  'imgEdit.deleteConfirm': 'Delete this image?',
  'imgEdit.deleteFailed': 'Delete failed, please try again',

  // Login / Register / Forgot password
  'login.close': 'Close',
  'login.title': 'Log in',
  'login.subtitle': 'Once logged in, your scenes will be saved automatically.',
  'login.email': 'Email',
  'login.password': 'Password',
  'login.passwordPlaceholder': 'Enter your password',
  'login.forgot': 'Forgot password?',
  'login.submit': 'Log in & Save',
  'login.noAccount': "Don't have an account?",
  'login.signup': 'Sign up',
  'register.title': 'Sign up',
  'register.subtitle': 'After signing up, your scenes will be saved automatically.',
  'register.confirmPassword': 'Confirm password',
  'register.passwordPlaceholder': 'Enter password (at least 6 characters)',
  'register.confirmPlaceholder': 'Re-enter password',
  'register.captcha': 'Verification code',
  'register.captchaPlaceholder6': 'Enter 6-digit verification code',
  'register.captchaPlaceholder8': 'Enter 8-digit verification code',
  'register.sendCode': 'Send code',
  'register.resendIn': 's to resend',
  'register.haveAccount': 'Already have an account?',
  'register.loginNow': 'Log in now',
  'register.submit': 'Sign up',
  'forgot.title': 'Reset password',
  'forgot.subtitle': 'Reset your password via email verification code.',
  'forgot.newPassword': 'New password',
  'forgot.newPasswordPlaceholder': 'Enter new password (at least 6 characters)',
  'forgot.submit': 'Reset password',
  'forgot.remember': 'Remember your password?',

  // Form validation
  'form.confirmPassword': 'Please confirm your password',
  'form.passwordMismatch': 'The two passwords do not match',
  'form.enterCaptcha': 'Please enter the verification code',
  'form.captchaLength': 'Verification code must be ',
  'form.captchaDigits': ' digits',
  'form.enterEmail': 'Please enter your email',
  'form.validEmail': 'Please enter a valid email address',
  'form.enterPassword': 'Please enter your password',
  'form.passwordMin': 'Password must be at least 6 characters',

  // AI Image to 3D Model
  'ai3d.title': 'AI Image to 3D Model',
  'ai3d.genProgress': 'Generation Progress',
  'ai3d.submitResult': 'Submission Result',
  'ai3d.jobId': 'Job ID: ',
  'ai3d.uploadImage': 'Upload Image',
  'ai3d.uploadHint': 'Click or drag to upload',
  'ai3d.formatHint': 'Supports JPG, PNG, and other common image formats',
  'ai3d.reupload': 'Re-upload',
  'ai3d.submitting': 'Submitting...',
  'ai3d.generating': 'Generating...',
  'ai3d.submitBtn': 'Generate 3D Model · 25 Credits',
  'ai3d.taskList': 'Model Generation Tasks',
  'ai3d.refresh': 'Refresh',
  'ai3d.submittingWait': 'Submitting, please wait...',
  'ai3d.uploadImageFile': 'Please upload an image file',
  'ai3d.genSuccess': 'Model generated successfully',
  'ai3d.generatingModel': 'Generating model...',
  'ai3d.queryTimeout': 'Query timed out, the task may still be processing',
  'ai3d.taskSubmitted': 'Task submitted, generating model...',
  'ai3d.submitSuccess': 'Task submitted successfully, generating model',
  'ai3d.submitFailed': 'Submission failed',
  'ai3d.submitFailedRetry': 'Submission failed, please try again later',

  // VIP / Pro modal
  'vip.title': 'Upgrade to Pro',
  'vip.choosePlan': 'Choose a Plan',
  'vip.priceLocked': '(Price locked for 12 months)',
  'vip.recommend': 'Recommended',
  'vip.daysBenefits': 'Enjoy ',
  'vip.daysBenefits2': ' days of Pro benefits',
  'vip.includes': 'Includes ',
  'vip.credits': ' credits',
  'vip.benefits': 'Pro Benefits',
  'vip.payMethod': 'Payment Method',
  'vip.checking': 'Verifying payment status...',
  'vip.unpaid': 'Payment not completed',
  'vip.retry': 'Retry',
  'vip.cancel': 'Cancel',
  'vip.paySuccess': 'Pro purchase successful!',
  'vip.planTitle.monthly': 'Monthly',
  'vip.planTitle.yearly': 'Annual',
  'vip.priceUnit.monthly': 'mo',
  'vip.priceUnit.yearly': 'yr',

  // Double 11 promotion
  'double11.tag': 'Studio · Singles Day Special',
  'double11.title': 'Buy 1 Month Pro, Get 1 Month Free',
  'double11.date': 'Offer ends Nov 30, 2026',
  'double11.cta': 'Upgrade to Pro →',

  // Buy Credits / Pay modal
  'pay.title': 'Buy AI Credits',
  'pay.subtitle': 'For AI scene generation and other AI features.',
  'pay.currentCredits': 'Current AI Credits',
  'pay.recommend': 'Recommended',
  'pay.afterPurchase': 'After Purchase',
  'pay.balance': 'Balance',
  'pay.buyNow': 'Buy Now',
  'pay.footer': 'Credits never expire · One purchase, lifetime use',
  'pay.credits': ' credits',
  'pay.checking': 'Verifying payment status...',
  'pay.unpaid': 'Payment not completed',
  'pay.retry': 'Retry',
  'pay.cancel': 'Cancel',
  'pay.success': 'Payment successful!',

  // AI Generation (aiPic)
  'aipic.back': 'Back to Workspace',
  'aipic.title': 'AI Generation',
  'aipic.credits': '{0} Credits',
  'aipic.refImages': 'Reference Images (up to 3)',
  'aipic.imageNo': 'Image {0}',
  'aipic.prompt': 'Prompt',
  'aipic.promptPlaceholder': 'Describe the image you want to generate...',
  'aipic.templates': 'Prompt Templates',
  'aipic.generating': 'Generating...',
  'aipic.generate': 'Generate Image (',
  'aipic.cost': '6 Credits)',
  'aipic.result': 'Result',
  'aipic.download': 'Download',
  'aipic.enterPrompt': 'Please enter a prompt',
  'aipic.success': 'Image generated successfully',
  'aipic.fail': 'Generation failed',
  'aipic.retryLater': 'Image generation failed, please try again',
  'aipic.template.realistic': 'Photorealistic',
  'aipic.template.ghibli': 'Ghibli Style',
  'aipic.template.anime': 'Anime',
  'aipic.template.pixar': 'Pixar 3D',
  'aipic.template.gamecg': 'Game CG',
  'aipic.template.oil': 'Oil Painting',
  'aipic.template.chinese': 'Chinese Ink',
  'aipic.template.storybook': "Children's Book",

  // Help modal
  'help.title': 'Help & Support',
  'help.wechat': 'WeChat ID:',
  'help.copy': 'Copy',
  'help.email': 'Email:',
  'help.sendEmail': 'Send Email',
  'help.copied': 'WeChat ID copied',
  'help.copyFailed': 'Copy failed',

  // Group QR modal
  'qr.title': 'Join WeChat Group to Earn Credits',
  'qr.tip': 'Scan the QR code above to add support on WeChat and get 20 credits',
  'qr.gotIt': 'Got it',

  // Community modal
  'community.title': 'Join Samelab\nCreator Community',
  'community.desc': 'Connect with AI creators, share your work, get product updates, and talk directly with the Samelab team.',
  'community.benefit1': 'Connect with AI creators',
  'community.benefit2': 'Share your work and workflows',
  'community.benefit3': 'Get product updates and early access',
  'community.benefit4': 'Talk directly with the Samelab team',
  'community.reward': 'Get 20 AI Credits',
  'community.rewardDesc': ' after joining',
  'community.qrTitle': 'Scan with WeChat to join',
  'community.qrFooter': 'Stay in touch with the Samelab team.',
  'community.later': 'Maybe later',

  // VIP benefits table
  'benefits.header': 'Features',
  'benefits.basic': 'Free',
  'benefits.pro': 'Pro',
  'benefits.giftCredits': 'Bonus Credits',
  'benefits.giftCreditsVip': 'Credit bonus',
  'benefits.animation': 'Animation & Timeline',
  'benefits.notSupported': 'Free (10s)',
  'benefits.supported': 'Unlimited',
  'benefits.storage': 'Cloud Storage',
  'benefits.hdExport': 'HD Image Export',
  'benefits.hdExportNormal': 'Standard',
  'benefits.hdExportVip': 'HD',

  // Material library (My Assets)
  'material.title': 'My Assets',
  'material.storage': 'Storage',
  'material.used': 'Used',
  'material.total': 'Total',
  'material.free': 'Available',
  'material.upload': 'Upload Asset',
  'material.uploadDesc': 'Supports FBX / OBJ / GLB',
  'material.settings': 'Settings',
  'material.delete': 'Delete',
  'material.deleteConfirm': 'Delete "{0}"?',
  'material.deleting': 'Deleting',
  'material.count': '{0} assets',
  'material.deleteFailed': 'Delete failed, please try again',

  // Import model confirm
  'import.title': 'Confirm Model Import',
  'import.tips': 'Drag to rotate · Scroll to zoom',
  'import.info': 'Model Info',
  'import.fileName': 'File Name:',
  'import.fileType': 'File Type:',
  'import.fileSize': 'File Size:',
  'import.scale': 'Scale:',
  'import.modelSize': 'Model Size:',
  'import.meshCount': 'Mesh Count:',
  'import.addToLibrary': 'Add to My Assets',
  'import.confirm': 'Import',
  'import.importing': 'Importing...',
  'import.uploading': 'Uploading to My Assets...',
  'import.spaceInsufficient': 'Not enough storage in My Assets. Available: {0}, Used: {1}, Total: {2}',

  // Publish model modal
  'publish.title': 'Model Settings',
  'publish.name': 'Model Name',
  'publish.namePlaceholder': 'Enter model name',
  'publish.isPublic': 'Publish to Public Library',
  'publish.public': 'Public',
  'publish.private': 'Private',
  'publish.publicTip': 'Other users can use it once published',
  'publish.price': 'Price (Credits)',
  'publish.priceTip': 'Other users pay to use it. Max 100 credits, 0 means free',
  'publish.category': 'Category',
  'publish.selectCategory': 'Select category',
  'publish.other': 'Other',
  'publish.scale': 'Scale',
  'publish.scaleTip': 'Drag the slider to preview the model scaling in real time',
  'publish.saving': 'Saving...',
  'publish.modelLoading': 'Loading model...',
  'publish.previewTips': 'Drag to rotate · Scroll to zoom · 1 axis unit = 1cm',
  'publish.noFile': 'This asset has no model file to preview',
  'publish.loadFailed': 'Failed to load model, please try again',
  'publish.nameRequired': 'Please enter a model name',
  'publish.categoryRequired': 'Please select a category',
  'publish.scaleInvalid': 'Please enter a valid scale (greater than 0)',
  'publish.saveFailed': 'Save failed, please try again',

  // Timeline
  'timeline.title': 'Timeline',
  'timeline.stop': 'Stop',
  'timeline.record': 'Record',
  'timeline.speed': 'x',
  'timeline.object': 'Object',
  'timeline.activeCamera': 'Active Camera',
  'timeline.cameraNo': 'Camera {0}',
  'timeline.upgradeVip': 'Upgrade to unlock longer duration',
  'timeline.noRecordContent': 'No recordable content on the timeline',
  'timeline.noCamera': 'Set up at least one camera to record',
  'timeline.recordEmpty': 'Recording is empty, please retry',
  'timeline.recordDone': 'Recording complete',
  'timeline.recordDoneInfo': 'Recording complete ({0}), video size: {1} MB',
  'timeline.upgradeVipPlay': 'Upgrade to unlock longer playback duration',
  'timeline.recordFail': 'Failed to export recording',
  'timeline.browserNoRecord': 'Current browser does not support video recording',
  'timeline.recordError': 'Error during recording',
  'timeline.deleteNode': 'Delete Node',
}

export default en
